export const viewTypeOptions = [
  { value: 1, label: '1 Day' },
  { value: 3, label: '3 Days' },
];
